import { useState, useEffect } from 'react';
import { cartCmsDataType, SopElementResponse } from '@commerce-cart-webcomponents/sdk';
import { useNextgenRouter } from '@nextgen-web-framework/all';
import { SubcriptionPlanCMSResponseType } from '@commerce-subscription-webcomponents/sdk';
import { fetchCmsContent, fetchSubscriptionCMSContent } from '../../utils/cmsApiCall';

export const useFetchCmsContent = () => {
  const [cmsData, setCmsData] = useState<cartCmsDataType>({});
  const router = useNextgenRouter();

  useEffect(() => {
    fetchCmsContent()
      .then((data) => {
        setCmsData(data);
      })
      .catch((error) => {
        throw error;
      });
  }, [router.params?.locale]);
  return cmsData;
};

export const useFetchSubscriptionCmsContent = (sopMetaData: SopElementResponse[]) => {
  const [sopCMSData, setSopCMSData] = useState<SubcriptionPlanCMSResponseType[]>();
  const router = useNextgenRouter();

  useEffect(() => {
    fetchSubscriptionCMSContent(sopMetaData)
      .then((data) => {
        setSopCMSData(data);
      })
      .catch((error) => {
        throw error;
      });
  }, [router.params?.locale, sopMetaData.length]);
  return sopCMSData;
};
